<button type="button" [ngClass]="cssClass()" class="w-100" [disabled]="disabled()">
  <ng-content />

  @if (isLoading()) {
    <span class="spinner-border spinner-border-sm ms-1" role="status" aria-hidden="true"></span>
  }
</button>
